import { Component, Input } from '@angular/core';

@Component({
    selector: 'ca-list-progress-bar',
    templateUrl: './list-progress-bar.component.html',
    styleUrls: ['./list-progress-bar.component.scss'],
})
export class ListProgressBarComponent {
    // Here we use an input to show and hide the progress bar so the content is not jumping up and down when the progress bar gets hidden or shown.
    @Input() isShown: false;
    @Input() label: string;
}
